import mixpanel from 'mixpanel-browser'

export const mixpanelTrack = (actionTitle, actionData) => {
    if (window.location.hostname === 'app.tuqqi.com'
        || window.location.hostname === 'desktop.tuqqi.com') {

        mixpanel.track("Web - " + actionTitle, actionData)
    }
}